export default __webpack_public_path__ + "static/media/recommended-icon.bfccd7dd.svg";